<div *ngIf="_color"
  class="colorbox"
  [style.background]="_color.colorval"
  [class.selected]="selected"
  [class.inverted]="_color.brightness < 0.3"
  [class.interactive]="behavior === 'interactive'"
  [class.static]="behavior === 'static'"
>
  <div class="colorname">{{ _color.name }}</div>
  <mat-icon>close</mat-icon>
</div>
